import { all, call, put, takeEvery, select } from "redux-saga/effects";
import {
    GET_DASHBOARD_DATA, GET_DASHBOARD_DATA_SUCCESS, SHOW__HIDE_LOADER, GET_ADMIN_DASHBOARD_DATA, GET_REGIONAL_ADMIN_DASHBOARD_DATA, GET_ADMIN_DASHBOARD_DATA_SUCCESS,
    GET_REGIONAL_ADMIN_DASHBOARD_DATA_SUCCESS, SURVEY_LIST_SUCCESS, SAVE_REMINDER_CONFIG, SAVE_REMINDER_CONFIG_ADMIN_SUCCESS, SAVE_REMINDER_CONFIG_REGIONAL_SUCCESS, GET_COUNTRY_MODULE_DATA, /* GET_COUNTRY_MODULE_DATA_SUCCESS, */ COUNTRY_BY_REGION_SUCCESS, MODULE_LIST_SUCCESS, UNMOUNT_DASHBOARD_DATA, UNMOUNT_DASHBOARD_DATA_SUCCESS, UNMOUNT_ADDEDIT_SURVEY_SUCCESS, DATACOLLECTOR_DASHBOARD_KEY, GET_DASHBOARD_DATA_OFFLINE, GET_DASHBOARD_DATA_OFFLINE_SUCCESS, GET_COUNTRY_MODULE_DATA_SUCCESS
} from './../constants/constants';
import { getDashboardData, getRegionalAdminDashboardData, getAdminDashboardData, saveReminderConfigCall, getCountyModuleTypeDashboardCall } from '../effects/api/api.userDashboard';
import { getSurveyListCall, getSurveyListDashboardCall } from 'src/effects/api/api.survey';
import { getAllCountriesByRegionCallById } from 'src/effects/api/api.common';
import { getModuleListBySurveyCall } from 'src/effects/api/api.module';
import { getLocalStorageValue } from 'src/effects/utils/local-storage';


function* getUserDashboard(countryData: any) {
    try {

        yield put({ type: SHOW__HIDE_LOADER, payload: true });

        const response = yield call(getDashboardData, countryData.payload);
        yield put({ payload: response, type: GET_DASHBOARD_DATA_SUCCESS });

        yield put({ type: SHOW__HIDE_LOADER, payload: false });

    } catch (err) {
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}

function* getAdminDashboard(data: any) {
    try {

        yield put({ type: SHOW__HIDE_LOADER, payload: true });
        const response = yield call(getAdminDashboardData, data.payload);

        if (data.payload.isDashboard) {
            const responseCountryRegion = yield call(getAllCountriesByRegionCallById, data);
            const responseModule = yield call(getModuleListBySurveyCall, data);
            yield put({ payload: responseCountryRegion, type: COUNTRY_BY_REGION_SUCCESS });
            yield put({ payload: responseModule, type: MODULE_LIST_SUCCESS });
        }

        if (!data.payload.isSurveyChangeEvent) {
            const responseSurvey = yield call(getSurveyListCall);
            yield put({ payload: responseSurvey, type: SURVEY_LIST_SUCCESS });
        }

        yield put({ payload: response, type: GET_ADMIN_DASHBOARD_DATA_SUCCESS });
        yield put({ type: SHOW__HIDE_LOADER, payload: false });


    } catch (err) {
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}

function* getRegionalAdminDashboard(data: any) {
    try {

        yield put({ type: SHOW__HIDE_LOADER, payload: true });

        if (data.payload.isDashboard) {
            const responseCountryRegion = yield call(getAllCountriesByRegionCallById, data);
            const responseModule = yield call(getModuleListBySurveyCall, data);

            yield put({ payload: responseCountryRegion, type: COUNTRY_BY_REGION_SUCCESS });
            yield put({ payload: responseModule, type: MODULE_LIST_SUCCESS });
        }

        if (!data.payload.isSurveyChangeEvent) {
            const responseSurvey = yield call(getSurveyListDashboardCall);
            yield put({ payload: responseSurvey, type: SURVEY_LIST_SUCCESS });
        }
        
        const response = yield call(getRegionalAdminDashboardData, data.payload);
        yield put({ payload: response, type: GET_REGIONAL_ADMIN_DASHBOARD_DATA_SUCCESS });

        yield put({ type: SHOW__HIDE_LOADER, payload: false });


    } catch (err) {
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}

function* saveReminderConfig(data: any) {
    try {

        yield put({ type: SHOW__HIDE_LOADER, payload: true });

        const response = yield call(saveReminderConfigCall, data);

        if (response.data.success) {
            const stateData = yield select(dashBoard);
            if (stateData) {
                if (stateData.userAdminDashboard.hasOwnProperty('frequency')) {
                    stateData.userAdminDashboard.frequency = data.payload.frequency;
                    stateData.userAdminDashboard.isSendForSurveyNotSubmitted = data.payload.Is_send_for_survey_not_submitted;
                    yield put({ payload: stateData, type: SAVE_REMINDER_CONFIG_ADMIN_SUCCESS });

                }
                if (stateData.userReionalAdminDashboard.hasOwnProperty('frequency')) {
                    stateData.userReionalAdminDashboard.frequency = data.payload.frequency;
                    stateData.userReionalAdminDashboard.isSendForSurveyNotSubmitted = data.payload.Is_send_for_survey_not_submitted;
                    yield put({ payload: stateData, type: SAVE_REMINDER_CONFIG_REGIONAL_SUCCESS });
                }
            }
        }

        yield put({ type: SHOW__HIDE_LOADER, payload: false });

    } catch (err) {
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}

function* getCountyModuleTypeDashboard(data: any) {
    try {

        yield put({ type: SHOW__HIDE_LOADER, payload: true });

        const response = yield call(getCountyModuleTypeDashboardCall, data.payload);
        yield put({ payload: response, type: GET_COUNTRY_MODULE_DATA_SUCCESS });

        yield put({ type: SHOW__HIDE_LOADER, payload: false });


    } catch (err) {
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}
function* unmountDashbordData() {
    try {

        yield put({ type: SHOW__HIDE_LOADER, payload: true });

        yield put({ payload: null, type: UNMOUNT_DASHBOARD_DATA_SUCCESS });
        yield put({ payload: null, type: UNMOUNT_ADDEDIT_SURVEY_SUCCESS });

        yield put({ type: SHOW__HIDE_LOADER, payload: false });


    } catch (err) {
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}

function* getUserDashboardOffline() {
    try {

        yield put({ type: SHOW__HIDE_LOADER, payload: true });

        const userId = getLocalStorageValue('user').id;
        const response = getLocalStorageValue(`UserId_${userId}_${DATACOLLECTOR_DASHBOARD_KEY}`);
        yield put({ payload: response, type: GET_DASHBOARD_DATA_OFFLINE_SUCCESS });

        yield put({ type: SHOW__HIDE_LOADER, payload: false });


    } catch (err) {
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}


export const dashBoard = (state: any) => state.userDashboard

export default function* UserDashboardSaga() {
    yield all([
        takeEvery(GET_DASHBOARD_DATA, getUserDashboard),
        takeEvery(GET_ADMIN_DASHBOARD_DATA, getAdminDashboard),
        takeEvery(GET_REGIONAL_ADMIN_DASHBOARD_DATA, getRegionalAdminDashboard),
        takeEvery(SAVE_REMINDER_CONFIG, saveReminderConfig),
        takeEvery(GET_COUNTRY_MODULE_DATA, getCountyModuleTypeDashboard),
        takeEvery(UNMOUNT_DASHBOARD_DATA, unmountDashbordData),
        takeEvery(GET_DASHBOARD_DATA_OFFLINE, getUserDashboardOffline),
    ])
}




// WEBPACK FOOTER //
// ./src/saga/saga.userDashboard.tsx